<template>
  <mdb-container>
    <mdb-card class="text-left">
      <mdb-card-header class="primary-color text-white">
        <h4>Background Image</h4>
      </mdb-card-header>
      <mdb-card-body>
        <mdb-btn @click="doCancel" size="sm" rounded>
          <mdb-icon icon="arrow-left"/>
        </mdb-btn>
        <mdb-btn v-if="type == 'event' && event.background" size="sm" rounded icon="times-circle" @click="imageSelected(null)">Remove Current image</mdb-btn>
        <mdb-btn v-if="type == 'group' && group.background" size="sm" rounded icon="times-circle" @click="imageSelected(null)">Remove Current image</mdb-btn>
        <mdb-card class="mb-4">
          <mdb-card-body>
            Choose an image from your library below to use as the background. The image will be sized to cover the screen,
            so cropping is likely to occur. Therefore, choose an image without words, logos, or any other elements that would make
            it look bad if it were cropped. The image should also be of a high enough resolution to fit
            a full-sized screen. In addition, a filter will be applied to the image to mute it so it blends with the site.
          </mdb-card-body>
        </mdb-card>
        <image-selector :group="group" emitOnSelection="imageSelected" @imageSelected="imageSelected" />
      </mdb-card-body>
    </mdb-card>
  </mdb-container>

</template>

<script>
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbChip,
  mdbContainer,
  mdbIcon,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import ImageSelector from "../group/ImageSelector";

export default {
    name: 'BackgroundChooser',
    components: {
      mdbBtn,
      mdbCard,
      mdbCardBody,
      mdbCardHeader,
      mdbContainer,
      mdbChip,
      mdbTblBody,
      mdbTblHead,
      mdbTbl,
      mdbIcon,
      mdbBadge,
      ImageSelector
    },
    props: {
      event: {
        type: Object,
        default: null
      },
      type : {
        type: String,
        default: "event"
      },
      referenceOnly: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      userDetails() {
        return this.$store.state.userDetails
      },
      group() {
        return this.$store.state.currentGroup
      },
      executing() {
        return this.$store.state.executing
      }
    },

    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      imageSelected(img) {
        if (this.referenceOnly) {
          this.$emit("newBackground", img )
          return
        }

        this.$store.dispatch("setExecuting", true);
        let payload = {}
        if (img) payload.image = img.id
        let url
        if (this.type == "group") url = "/group/setBackground/" + this.group.id
        else url = "/event/setBackground/" + this.event.eventId
        api.post(url, payload).then(
          (results) => {
            this.$emit("newBackground", img ? img.url : null)
          },
          (error) => {
            this.$notify.error({message: "Could not set image. " + error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      doCancel() {
        this.$emit("close")
      },
    }
  }
  ;
</script>
